import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { UserPINVerifyPage } from 'src/app/modals/user-pin-verify/user-pin-verify.page';

const routes: Routes = [
  {
    path: '',
    component: UserPINVerifyPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [UserPINVerifyPage]
})
export class UserPINVerifyPageModule {}
